import React from 'react'
import { useSelector } from 'react-redux'
import { PlanDetails } from './components'

export function PlanDrawer() {
  const { stage } = useSelector(({ drawer }) => drawer)

  return stages()[stage]
}

function stages() {
  return {
    initial: <PlanDetails />,
  }
}
